export default __webpack_public_path__ + "static/media/ArticleNyTimes.d23f0fdf.svg";